function simulateSwipeLeft(carousel) {
  const mouseDownEvent = new MouseEvent("mousedown", {
    clientX: 200,
    clientY: 0,
    bubbles: true,
    cancelable: true,
  });
  const mouseMoveEvent = new MouseEvent("mousemove", {
    clientX: 0,
    clientY: 0,
    bubbles: true,
    cancelable: true,
  });
  const mouseUpEvent = new MouseEvent("mouseup", {
    bubbles: true,
    cancelable: true,
  });

  carousel.dispatchEvent(mouseDownEvent);
  carousel.dispatchEvent(mouseMoveEvent);
  carousel.dispatchEvent(mouseUpEvent);
}

function simulateSwipeRight(carousel) {
  const mouseDownEvent = new MouseEvent("mousedown", {
    clientX: 0,
    clientY: 0,
    bubbles: true,
    cancelable: true,
  });
  const mouseMoveEvent = new MouseEvent("mousemove", {
    clientX: 200,
    clientY: 0,
    bubbles: true,
    cancelable: true,
  });
  const mouseUpEvent = new MouseEvent("mouseup", {
    bubbles: true,
    cancelable: true,
  });

  carousel.dispatchEvent(mouseDownEvent);
  carousel.dispatchEvent(mouseMoveEvent);
  carousel.dispatchEvent(mouseUpEvent);
}

document.addEventListener("click", function (event) {
  const carousel = document.querySelector(
    ".cart-drawer-recommended-products .card-carousel__container"
  );

  if (event.target.closest(".card-drawer__recommended-arrow--prev")) {
    simulateSwipeRight(carousel);
  }

  if (event.target.closest(".card-drawer__recommended-arrow--next")) {
    simulateSwipeLeft(carousel);
  }
});
